import React from 'react';
import useLoginForm from './useLoginForm';

const SessionManager = ({ children }) => {
  useLoginForm(); // Esto configurará el temporizador de inactividad

  return <>{children}</>;
};

export default SessionManager;